/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ReactComponent as Icon } from 'Images/icon-toolbar-delete.svg';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 264px;
  height: 38px;
  background: ${({ theme }) => theme.backgrounds.listItemOdd};
`;
Wrapper.displayName = 'Wrapper';

export const TrashIcon = styled(Icon)`
    height: 18px;
    width: 18px;
    path, rect {
      fill: ${colors.red1};
    }
    ${({ disabled }) => disabled && 'opacity: 0.5; pointer-events: none'};
`;
TrashIcon.displayName = 'TrashIcon';
